export const initAppMetadataMock = {
  appId: 'itero-aohs',
  appMetadata: "{\"data\": 'some data'}",
};
